import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
const AddLeadType = ({ show, onClose, refresh }) => {
    const [name, setname] = useState('');
    const [contact, setcontact] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [existing, setExisting] = useState([]);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const contact_type = [
        { value: 1, label: "Contact Number" },
        { value: 2, label: "Email Address" },
        { value: 3, label: "WhatsApp Number" }
    ];

    useEffect(() => {
        if (show) {
            axios.get(`${baseURL}/helpdesk`) 
                .then(response => {
                    setExisting(response.data.data.map(leadtype => leadtype.contact.toLowerCase()));
                })
                .catch(error => {
                    console.error("Error fetching data", error);
                });
        }
    }, [show]);

    const formatleadtypeName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const validate = () => {
        const newErrors = {};
        if (!name) {
            newErrors.name = "This Field is Required.";
        }  else {
            if ((name === 1 || name === 3) && (!/^\d{10}$/.test(contact))) {
                newErrors.contact = "Please enter a valid 10-digit mobile number.";
            } else if (name === 2 && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact))) {
                newErrors.contact = "Please enter a valid email address.";
            }
        }

        if (!contact.trim()) {
            newErrors.contact = "This Field is Required.";
        } else if (existing.includes(contact.toLowerCase())) {
            newErrors.contact = "This contact already exists.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            name: name,
            contact: contact,
            description: description.trim() || "" 
        };
        

        // Send the request to the backend
        axios.post(`${baseURL}/helpdesk`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Contact Created Successfully!");
            })
            .catch(error => {
                console.error("Error:", error);
                toast.error("Contact Creation Failed");
            });
    };


    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Contact</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Contact Type<span className="required">*</span></label>
                            {/* <input type="text" className="form-control" placeholder="Enter Name"
                                value={name} 
                                onChange={(e) => setname(formatleadtypeName(e.target.value))} 
                            /> */}

                            <Select
                                options={contact_type}
                                onChange={(e) => setname(e.value)}
                                placeholder="Select Type"
                            />

                            {errors && <small className="text-danger">{errors.name}</small>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Contact<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Contact"
                                value={contact} 
                                onChange={(e) => setcontact(e.target.value)} 
                            />
                            {errors.contact && <small className="text-danger">{errors.contact}</small>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description" value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button type="submit" className="btn btn-sm btn-primary">Create Contact<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddLeadType;
